import { render } from "./Navbar.vue?vue&type=template&id=0be26456"
const script = {}

import exportComponent from "/home/irevors/CODING/ESTUDIOS/SENCE/ensayo prueba TD/ensayo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__